/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface TryChangeConfigRequest
 */
export interface TryChangeConfigRequest {
  /**
   *
   * @type {string}
   * @memberof TryChangeConfigRequest
   */
  sessionId: string
  /**
   *
   * @type {string}
   * @memberof TryChangeConfigRequest
   */
  input: string
}

/**
 * Check if a given object implements the TryChangeConfigRequest interface.
 */
export function instanceOfTryChangeConfigRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'sessionId' in value
  isInstance = isInstance && 'input' in value

  return isInstance
}

export function TryChangeConfigRequestFromJSON(
  json: any,
): TryChangeConfigRequest {
  return TryChangeConfigRequestFromJSONTyped(json, false)
}

export function TryChangeConfigRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TryChangeConfigRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sessionId: json['session_id'],
    input: json['input'],
  }
}

export function TryChangeConfigRequestToJSON(
  value?: TryChangeConfigRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    session_id: value.sessionId,
    input: value.input,
  }
}
